import { render, staticRenderFns } from "./ksgl.vue?vue&type=template&id=c67b7730&scoped=true"
import script from "./ksgl.vue?vue&type=script&lang=js"
export * from "./ksgl.vue?vue&type=script&lang=js"
import style0 from "../../views/matrix-page/assets/css/rem.css?vue&type=style&index=0&id=c67b7730&prod&scoped=true&lang=css&external"
import style1 from "./ksgl.vue?vue&type=style&index=1&id=c67b7730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67b7730",
  null
  
)

export default component.exports